// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import React from "react";
// Customizable Area End

export interface Props {
    navigation: any;
    id: string;
    // Customizable Area Start
    // Customizable Area End
}

interface S {
    // Customizable Area Start
    onSearch: string;
    // Customizable Area End
}

interface SS {
    id: any;
    // Customizable Area Start
    // Customizable Area End
}

export default class AppHeaderController extends BlockComponent<
    Props,
    S,
    SS
> {
    // Customizable Area Start
    // Customizable Area End

    constructor(props: Props) {
        super(props);
        this.receive = this.receive.bind(this);

        // Customizable Area Start
        this.subScribedMessages = [
            // Customizable Area Start
            getName(MessageEnum.NavigationPayLoadMessage),
            // Customizable Area End
        ];

        this.state = {
            // Customizable Area Start
            onSearch: "",
            // Customizable Area End
        };
        runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

        // Customizable Area Start
        // Customizable Area End
    }

    async receive(from: string, message: Message) {
        // Customizable Area Start
        // Customizable Area End
    }

    // Customizable Area Start
    handleHeaderLogoClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        this.props.navigation.navigate('LandingPage');
    }

    handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            onSearch: event.target.value,
        });
    };

    handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            const payloadData = { showProfile: true, searchTerm: this.state.onSearch }
            const msgNavigation = new Message(getName(MessageEnum.NavigationMessage));
            msgNavigation.addData(getName(MessageEnum.NavigationTargetMessage), "AddFriends");
            msgNavigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
            const raiseMessage: Message = new Message(getName(MessageEnum.NavigationPayLoadMessage));
            raiseMessage.addData(getName(MessageEnum.NavigationPayLoadMessage), payloadData);
            msgNavigation.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
            this.send(msgNavigation);
        }
    };
    // Customizable Area End
}
